import { useQuery } from "@tanstack/react-query";
import { queueApi } from "@bw/shared/api";
import type { QueueEntryResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/** Recover the caller's active facility queue/line entry, if one exists. */
export function useMyQueueEntry(
  facilityId: string,
  enabled: boolean = true,
) {
  return useQuery<QueueEntryResponse | null>({
    queryKey: queryKeys.dropin.myQueueEntry(facilityId),
    queryFn: () => queueApi.getMyEntry(facilityId),
    enabled: Boolean(facilityId) && enabled,
    retry: false,
    refetchOnWindowFocus: "always",
    refetchOnReconnect: "always",
  });
}
